import { SearchOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import SearchComponent from 'components/Global/SearchComponent';
import { useContext } from 'react';
import styles from './index.module.scss';

type Props = {
	searchValue: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	button: any;
};

const JobGradeHeader = (props: Props) => {
	const { searchValue, handleSearch, handleSearchApi, button } = props;

	const permissions = useContext(PermissionContext);

	return (
		<div className={styles['employee-header']}>
			<Space>
				<SearchComponent
					className={styles['employee-header-item']}
					placeHolder="Search by title or position..."
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchValue}
					size="large"
				/>
			</Space>
			{permissions.allowedPermissions.includes('Add_Job_Grade') && (
				<Space>
					<Buttons buttons={button} />
				</Space>
			)}
		</div>
	);
};

export default JobGradeHeader;
